export default __webpack_public_path__ + "static/media/PropertyDev_IMG-NationalCamp.b37bcab2.png";